import type { ModelComplexity } from "../types";

export const MONTHLY_MENU_EXTRA_MONTHS_MIN = 0;
export const MONTHLY_MENU_EXTRA_MONTHS_MAX = 11;
export const MONTHLY_MENU_EXTRA_MONTHS_DEFAULT = 1;

/** Extra months after the effective month (0 = effective only, 1 = effective + one more month). */
export function getMonthlyMenuExtraMonths(model?: ModelComplexity | null): number {
    const n = model?.monthlyMenuExtraMonths;
    if (n == null || Number.isNaN(n)) {
        return MONTHLY_MENU_EXTRA_MONTHS_DEFAULT;
    }
    return Math.min(MONTHLY_MENU_EXTRA_MONTHS_MAX, Math.max(MONTHLY_MENU_EXTRA_MONTHS_MIN, Math.round(n)));
}

/** First day of each month: effective month plus `extraMonths` additional months. */
export function buildMonthlyMenuMonthDates(effectiveMonth: Date, extraMonths: number): Date[] {
    const clamped = Math.min(MONTHLY_MENU_EXTRA_MONTHS_MAX, Math.max(MONTHLY_MENU_EXTRA_MONTHS_MIN, Math.round(extraMonths)));
    const baseYear = effectiveMonth.getFullYear();
    const baseMonth = effectiveMonth.getMonth();
    const dates: Date[] = [];
    for (let offset = 0; offset <= clamped; offset++) {
        dates.push(new Date(baseYear, baseMonth + offset, 1));
    }
    return dates;
}
